/**
 * @generated SignedSource<<9a557efe0cdbe95238b28282bcb721b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type portals_eventPortal$data = {
  readonly endDate: any;
  readonly id: string;
  readonly slug: string;
  readonly startDate: any;
  readonly title: string;
  readonly " $fragmentType": "portals_eventPortal";
};
export type portals_eventPortal$key = {
  readonly " $data"?: portals_eventPortal$data;
  readonly " $fragmentSpreads": FragmentRefs<"portals_eventPortal">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "portals_eventPortal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};

(node as any).hash = "7109179c64d97e0eebfbefb6908e003c";

export default node;
